import { IPagination } from "../../Utils/types";

interface IPaginationState {
  paginationInfo: IPagination,
}
const paginationState: IPaginationState = {
  paginationInfo: {
    page: 1,
    elsePages: false
  },
}

// Action types
export const SET_PAGINATION = 'pagination/SET_PAGINATION';

// Selectors
export const paginationInfoSelector = (state: any) => state.pagination.paginationInfo;

// Reducer
export function paginationReducer(state: IPaginationState = paginationState, action: any) {
  switch (action.type) {
    case SET_PAGINATION: {
      return {
        ...state,
        paginationInfo: {
          page: action.page,
          elsePages: action.elsePages
        }
      }
    }

    default: {
      return state;
    }
  }
}

// Actions
interface SetPaginationType {
  type: typeof SET_PAGINATION,
  page: number,
  elsePages: boolean
}

export function setPagination(page: number, elsePages: boolean): SetPaginationType {
  return {
    type: SET_PAGINATION,
    page: +page,
    elsePages
  }
}

export type PaginationActions = SetPaginationType;